module.exports = __webpack_public_path__ + "img/ornament-7923631_1280.e76e666f.png";